export default __webpack_public_path__ + "static/zielona-gospodarka-logo-1debba87060eaf6bf9656918a081fa4d.png";